module.exports = __webpack_public_path__ + "img/slyy.3726297a.jpg";